import { BoosterAllowances } from '@interfaces/booster-allowances';
import { getCall } from '@services/rest-service';

// Retrieves all the booster allowances from cosmos
export const getBoosterAllowances = (): Promise<BoosterAllowances[]> => {
  return getCall<BoosterAllowances[]>('booster-allowances');
};